import { styled } from 'twin.macro';

const Logo = styled.img`
  margin-inline-end: 2rem;
  max-width: 100px;
  max-height: 40px;
`;

export default Logo;
